import React from 'react'
import Resturent from './Compnent/Basics/Resturent'
const App = () => {
  return <Resturent/>
}

export default App
